import { encodeCameraParameters } from "@/components/r3f/utils/camera-parameters";
import { changeMode } from "@/store/mode-slice";
import {
  selectReturnCamera,
  selectReturnMode,
} from "@/store/modes/export-mode-selectors";
import {
  setSelectedExportModeTab,
  setShouldStoreCameraPosition,
} from "@/store/modes/export-mode-slice";
import { AppDispatch, AppStore } from "@/store/store";
import { deactivateTool } from "@/store/ui/ui-slice";
import { ExportModeTab } from "./export-mode-types";

/**
 * Ends the export mode and return to the previous mode restoring the previous camera
 *
 * @param store to access the stored mode/camera information
 * @param dispatch to update the app state
 */
export function returnToPreviousMode(
  store: AppStore,
  dispatch: AppDispatch,
): void {
  const returnMode = selectReturnMode(store.getState());
  const returnCamera = selectReturnCamera(store.getState());
  const initialState = returnCamera
    ? { camera: encodeCameraParameters(returnCamera) }
    : undefined;
  dispatch(changeMode({ mode: returnMode, initialState }));
  dispatch(deactivateTool());
}

/**
 * Moves to the export mode with the given tab selected
 *
 * @param dispatch to update the app state
 * @param selectedTab the tab to select when entering the export mode
 * @param shouldStoreCameraPosition whether to store the current camera position to restore it when exiting the export mode
 */
export function moveToExportMode(
  dispatch: AppDispatch,
  selectedTab: ExportModeTab,
  shouldStoreCameraPosition?: boolean,
): void {
  dispatch(setSelectedExportModeTab(selectedTab));
  dispatch(setShouldStoreCameraPosition(shouldStoreCameraPosition));
  dispatch(changeMode("export"));
}
